type IconProps = {
  className?: string;
};

function iconProps(className?: string) {
  return {
    className,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.9,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    "aria-hidden": true,
  };
}

export function HomeIcon({ className }: IconProps) {
  return (
    <svg {...iconProps(className)}>
      <path d="M4 11.2 12 4l8 7.2" />
      <path d="M6.8 10.4v8.1c0 .8.6 1.4 1.4 1.4h7.6c.8 0 1.4-.6 1.4-1.4v-8.1" />
      <path d="M9.6 19.9v-5.2c0-.6.5-1.1 1.1-1.1h2.6c.6 0 1.1.5 1.1 1.1v5.2" />
    </svg>
  );
}

export function ChatIcon({ className }: IconProps) {
  return (
    <svg {...iconProps(className)}>
      <path d="M5.2 5.6h13.6c.9 0 1.6.7 1.6 1.6v7.2c0 .9-.7 1.6-1.6 1.6h-7.5l-4.5 3v-3H5.2c-.9 0-1.6-.7-1.6-1.6V7.2c0-.9.7-1.6 1.6-1.6Z" />
      <path d="M7.8 9.4h8.4" />
      <path d="M7.8 12.3h5.5" />
    </svg>
  );
}

export function CalendarIcon({ className }: IconProps) {
  return (
    <svg {...iconProps(className)}>
      <path d="M6.5 4.4v3" />
      <path d="M17.5 4.4v3" />
      <path d="M4.8 7h14.4c.8 0 1.5.7 1.5 1.5v10.1c0 .8-.7 1.5-1.5 1.5H4.8c-.8 0-1.5-.7-1.5-1.5V8.5C3.3 7.7 4 7 4.8 7Z" />
      <path d="M3.7 11h16.6" />
      <path d="M7.2 14.2h2.2" />
      <path d="M12.9 14.2h3.9" />
      <path d="M7.2 17h6.1" />
    </svg>
  );
}

export function DocsIcon({ className }: IconProps) {
  return (
    <svg {...iconProps(className)}>
      <path d="M7.1 3.9h6.8l4.2 4.2v10.4c0 .9-.7 1.6-1.6 1.6H7.1c-.9 0-1.6-.7-1.6-1.6v-13c0-.9.7-1.6 1.6-1.6Z" />
      <path d="M13.8 4.1v4.2h4.2" />
      <path d="M8.6 12h6.8" />
      <path d="M8.6 15h6.1" />
      <path d="M8.6 18h3.5" />
    </svg>
  );
}

export function DefaultProfileIcon({ className }: IconProps) {
  return (
    <svg {...iconProps(className)}>
      <path d="M12 12.2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" />
      <path d="M5.2 20.1c.8-3.4 3.2-5.4 6.8-5.4s6 2 6.8 5.4" />
      <path d="M7.3 20.1h9.4" />
    </svg>
  );
}

export function SearchIcon({ className }: IconProps) {
  return (
    <svg {...iconProps(className)}>
      <path d="M10.6 17.2a6.2 6.2 0 1 0 0-12.4 6.2 6.2 0 0 0 0 12.4Z" />
      <path d="m15.1 15.1 4.1 4.1" />
    </svg>
  );
}

export function FilesIcon({ className }: IconProps) {
  return (
    <svg {...iconProps(className)}>
      <path d="M3.5 7.8h6l1.7 2h9.3v8.3c0 1.1-.8 1.9-1.9 1.9H5.4c-1.1 0-1.9-.8-1.9-1.9V7.8Z" />
      <path d="M5.4 7.8V5.9c0-1 .8-1.8 1.8-1.8h4.1l1.7 2h4c1 0 1.8.8 1.8 1.8v1.9" />
      <path d="M8 13h8" />
      <path d="M8 16h5" />
    </svg>
  );
}

export function AiSearchIcon({ className }: IconProps) {
  return (
    <svg {...iconProps(className)}>
      <circle cx="10.4" cy="10.4" r="6.8" />
      <path d="m15.4 15.4 4.2 4.2" />
      <text x="10.4" y="11.9" textAnchor="middle" fontSize="5.1" fontWeight="700" fill="currentColor" stroke="none">
        AI
      </text>
    </svg>
  );
}

export function NotificationIcon({ className }: IconProps) {
  return (
    <svg {...iconProps(className)}>
      <path d="M18.1 10.3c0-3.3-2.2-5.7-6.1-5.7s-6.1 2.4-6.1 5.7c0 4-1.3 5.4-2.2 6.3h16.6c-.9-.9-2.2-2.3-2.2-6.3Z" />
      <path d="M9.4 19.1c.5.8 1.4 1.3 2.6 1.3s2.1-.5 2.6-1.3" />
    </svg>
  );
}

export function ChevronDownIcon({ className }: IconProps) {
  return (
    <svg {...iconProps(className)}>
      <path d="m6.8 9.4 5.2 5.2 5.2-5.2" />
    </svg>
  );
}
